module.exports = __webpack_public_path__ + "static/emma_2-5539bf98731cbeaec86ed2f64ef77f33.gif";